import React, { Component } from 'react';
import { connect } from 'react-redux'
import { loadRiskProfiles, setPageNo, setSortBy, setFilterBy } from '../../store/entities/credentialMonitoring';
import RiskProfiles from './RiskProfiles';
import { setCurrentCustomer } from '../../store/entities/customers';
import { isCredentialMonitoringEnabled } from '../../utilities/config';


class CredentialMonitoring extends Component {
    state = {
        activeTab: 'logins', // 'logins' or 'passwords'
        data: this.props.riskProfiles || [],
        srchTxt: '',
        sortField: null,
        sortOrder: 'asc',
        resetOnChange: false
    }

    componentDidMount() {
        // Load credential monitoring data from Redux store
        const { selectedCustomer, filterBy, sortBy, pageNo, pageSize } = this.props;
        let customerId = selectedCustomer ? selectedCustomer.id : null;
        let paramCustomerId = this.props.match?.params?.id;
        this.props.loadRiskProfiles(paramCustomerId || customerId, filterBy, sortBy, pageNo, pageSize)
        // Parse initial sort from props
        this.parseSortBy(sortBy);
    }

    onActionClick = (item) => {
        this.props.history.push({ pathname: `/customers/${this.props.selectedCustomer.id}/risk-profiles/${item.userId}`, state: { username: item.userId } });
    }

    componentDidUpdate(prevProps, prevState) {
        
        let arrSelectedCustomer = this.props.customers.filter((ele) => ele.id === this.props.match.params.id);
        if(arrSelectedCustomer.length > 0){
            this.props.setCurrentCustomer(arrSelectedCustomer[0]);
        }
        
        // Monitor Redux state changes for filters and sorting
        if(prevProps.filterBy !== this.props.filterBy || prevProps.sortBy !== this.props.sortBy) {
            this.setState({ resetOnChange: !this.state.resetOnChange });
            this.props.setPageNo(1);
            this.props.loadRiskProfiles(this.props.selectedCustomer.id, this.props.filterBy, this.props.sortBy, 1, this.props.pageSize);
        }
        
        // Check if customer changed
        if(prevProps.selectedCustomer?.id !== this.props.selectedCustomer?.id && this.props.selectedCustomer?.id){
            const { selectedCustomer, sortBy, pageNo, pageSize } = this.props;
            this.props.loadRiskProfiles(selectedCustomer.id, this.props.filterBy, sortBy, pageNo, pageSize);
            this.parseSortBy(sortBy);
        }
    }

    parseSortBy = (sortBy) => {
        if (sortBy) {
            const parts = sortBy.split('|');
            if (parts.length === 2) {
                this.setState({
                    sortField: parts[0],
                    sortOrder: parts[1]
                });
            }
        }
    }

    handleSort = (fieldName) => {
        const { sortField, sortOrder } = this.state;
        const { setPageNo } = this.props;
        
        let newSortOrder;
        if (sortField === fieldName) {
            // Same field clicked - toggle current state
            newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            // Different field clicked - inactive fields are visually 'asc', so toggle to 'desc'
            newSortOrder = 'desc';
        }
        
        this.setState({
            sortField: fieldName,
            sortOrder: newSortOrder
        });

        const sortByString = `${fieldName}|${newSortOrder}`;
        this.props.setSortBy(sortByString);
    }

    handleSearch = (searchText) => {
        // Debounce effect
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
            const filterByString = `srchTxt|${searchText}`;
            this.setState({ srchTxt: searchText });
            
            // Update Redux filterBy - componentDidUpdate will handle the rest
            this.props.setFilterBy(filterByString);
        }, 500);
    }

    getPrevPageData = (pageNo, pageSize) => {
        const { selectedCustomer, filterBy, sortBy } = this.props;
        if (selectedCustomer) {          
            // Load data for the new page
            this.props.loadRiskProfiles(selectedCustomer.id, filterBy, sortBy, pageNo, pageSize);
            this.props.setPageNo(pageNo);
        }
    }
    
    getNextPageData = (pageNo, pageSize) => {
        const { selectedCustomer, filterBy, sortBy, loadRiskProfiles } = this.props;
        loadRiskProfiles(selectedCustomer.id, filterBy, sortBy, pageNo, pageSize);
        this.props.setPageNo(pageNo);
    }

    render() {
        let { riskProfiles, loading, userRole, selectedCustomer, pageNo, pageSize, isLastPage } = this.props;
        return (
            <div>
                <div></div>
                {/* {this.renderRingChart()} */}
                {/* Tabbed Table */}
                <div className={'mt-2 ml-2'}>
                {
                    userRole === "PixmAdmin" ? 
                    selectedCustomer && isCredentialMonitoringEnabled(selectedCustomer) ? 
                    <RiskProfiles 
                        riskProfiles={riskProfiles} 
                        loading={loading}
                        handleSearch={this.handleSearch}
                        srchTxt={this.state.srchTxt}
                        handleSort={this.handleSort}
                        onActionClick={this.onActionClick}
                        sortField={this.state.sortField}
                        sortOrder={this.state.sortOrder}
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalSize={this.props.totalSize}
                        currentPageRecords={riskProfiles}
                        isLastPage={isLastPage}
                        getPrevPageData={this.getPrevPageData}
                        getNextPageData={this.getNextPageData}
                        resetOnChange={this.state.resetOnChange}
                     />
                    : <div>
                        <div id="not-found"><h3 style={{textAlign : "center"}}>Credential Monitoring is not enabled for this customer</h3></div>
                    </div>
                    :
                    <div>
                        <div id="not-found"><h3 style={{textAlign : "center"}}>You are not authorized to view this page.</h3></div>
                    </div>
                }
                
                        
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedCustomer: state.entities.customers.selected,
    riskProfiles: state.entities.credentialMonitoring.data.riskProfiles,
    loading : state.entities.credentialMonitoring.loading,
    filterBy: state.entities.credentialMonitoring.filterBy,
    sortBy: state.entities.credentialMonitoring.sortBy,
    pageNo: state.entities.credentialMonitoring.pageNo,
    pageSize: state.entities.credentialMonitoring.pageSize,
    maxPageNo: state.entities.credentialMonitoring.maxPageNo,
    isLastPage: state.entities.credentialMonitoring.isLastPage,
    totalSize: state.entities.credentialMonitoring.totalSize,
    userRole: state.entities.user.roles,
    customers: state.entities.customers.list
});

const mapDispatchToProps = (dispatch) => ({
     loadRiskProfiles: (customerId, filterBy, sortBy, pageNo, pageSize) => dispatch(loadRiskProfiles(customerId, filterBy, sortBy, pageNo, pageSize)),
     setPageNo: (pageNo) => dispatch(setPageNo({ pageNo })),
     setSortBy: (sortBy) => dispatch(setSortBy(sortBy)),
     setFilterBy: (filterBy) => dispatch(setFilterBy(filterBy)),
     setCurrentCustomer: (customerId) => dispatch(setCurrentCustomer(customerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CredentialMonitoring);
